<template>
  <div>
    <div class="mwe-page-product-wrapper-filter-mobile-overlay" :class="{'show': openFilterProductMobile}"></div>
    <div id="mwe-page-product-wrapper-filter-mobile" class="mwe-page-product-wrapper-filter-mobile" :class="{'expand': openFilterProductMobile}" :style="cssVars">
      <b-overlay :show="loading" rounded="sm" style="width: 100%;">
        <div class="mwe-page-product-filter vh-100">
          <div class="product-filter-box d-flex align-items-center justify-content-between">
            <div class="product-filter-title-mobile">{{$t('website.pageProduct.lblFilter', languageUse)}}<span class="ml-gd-1">({{numItemFilterSelected}})</span></div>
            <div class="close-btn fs-18 cursor-pointer" @click="closeMenu()">
              <i class="fal fa-times"></i>
            </div>
          </div>
          <div class="filter-scroll-wrapper" v-if="filterData && render">
            <div class="product-filter-box" :class="comp.isShow ? '' : 'd-none'" v-for="(comp, comp_index) in arrayDisplay" :key="comp_index" v-show="!(comp.type =='rating' && hideFilterRating)">
              <component v-if="comp.type != 'stock'"
                :is="comp.name"
                :dataComp="getDataRenderComponent(comp.type)"
                :name="comp.filterName"
                :device="detectDevice"
                @change="(val) => onChange(comp.type, val)"
              ></component>
              <div class="filter-checkbox d-flex" style="align-items: baseline;" v-else>
                <b-form-checkbox
                  v-model="selectedInstock"
                  @change="(val) => onChange('stock', val)"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
                <p class="mwe-page-product-filter-list mb-0" style="cursor: unset">
                  {{$t('website.pageProduct.filter.lblShowOnlyAvailableStock', languageUse)}}
                </p>
              </div>
            </div>
          </div>
          <div class="product-filter-box button-box d-flex align-items-center justify-content-end">
            <b-button class="clear" @click="clearFilter">Clear filter</b-button>
            <b-button class="apply" @click="apply">Apply</b-button>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import color from "@helpers/color.helper";
import fontSizeConfigs from "@model/fontSizeConfigs/pageProduct";
import { responsiveFontSize } from "@helpers/text.helper";
import productWebsiteService from "@services/productWebsiteService.js"

const filterComp = {
  ProductFilterCategory: () =>
    import(
      /* webpackChunkName: "ProductFilterCategory" */ "@components/dynamic/SectionPageProduct/ProductFilter/ProductFilterComp/ProductFilterCategory.vue"
    ),
  ProductFilterAttribute: () =>
    import(
      /* webpackChunkName: "ProductFilterAttribute" */ "@components/dynamic/SectionPageProduct/ProductFilter/ProductFilterComp/ProductFilterAttribute.vue"
    ),
  ProductFilterBrand: () =>
    import(
      /* webpackChunkName: "ProductFilterBrand" */ "@components/dynamic/SectionPageProduct/ProductFilter/ProductFilterComp/ProductFilterBrand.vue"
    ),
  ProductFilterPrice: () =>
    import(
      /* webpackChunkName: "ProductFilterPrice" */ "@components/dynamic/SectionPageProduct/ProductFilter/ProductFilterComp/ProductFilterPrice.vue"
    ),
  ProductFilterRating: () =>
    import(
      /* webpackChunkName: "ProductFilterRating" */ "@components/dynamic/SectionPageProduct/ProductFilter/ProductFilterComp/ProductFilterRating.vue"
    ),
  ProductFilterStatus: () =>
    import(
      /* webpackChunkName: "ProductFilterStatus" */ "@components/dynamic/SectionPageProduct/ProductFilter/ProductFilterComp/ProductFilterStatus.vue"
    ),
};

export default {
  props: [],
  components: {
    ...filterComp,
  },
  data() {
    return {
      loading: false,
      render: true,
      openMenu: true,
      fontSizeConfigs,
      filterData: undefined,
      isEnableCategory: true,
      isEnableBrand: true,
      isEnableAttribute: true,
      isEnablePrice: true,
      isEnableRating: true,
      isEnableStatus: true,
      isEnableStock: true,
      categories: undefined,
      brands: undefined,
      attributes: undefined,
      prices: undefined,
      ratings: undefined,
      status: undefined,
      selectedCategory: ["0", "0", "0", "0"],
      selectedAttributes: [],
      selectedBrands: [],
      selectedPrices: { min: undefined, max: undefined },
      selectedRatings: [],
      selectedStatus: [],
      selectedInstock: false,
      paramsUrlFilter: '',
    };
  },
  watch: {
    openFilterProductMobile: {
      handler(next, prev) {
        if (!prev, next) {
          this.getFilterProduct()
        }
      }
    },
    categoryID: {
      handler() {
        this.getFilterProduct()
      },
      deep: true
    },
    filterData: {
      handler() {
        this.reRender()
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters({
      preview: "designIframe/preview",
      detectDevice: "detectDevice",
      languageUse: "designIframe/metadata/siteActiveLanguage",
      appearance: "designIframe/metadata/appearance",
      appearanceLanguage: "designIframe/metadata/appearanceLanguage",
      pageProductConfig: "designIframe/metadata/mainPageProductConfig",
      pageProductStyle: "designIframe/metadata/siteStylePageProduct",
      pageProductData: "designIframe/metadata/siteDataPageProduct",
      pageProductComponent: "designIframe/metadata/pageComponents",
      openFilterProductMobile: "designIframe/openFilterProductMobile",
      permissionWebsite: "designIframe/permissionWebsite/permissions",
      productReviewConfig: "designIframe/page/productReviewConfig",
    }),
    isMobile() {
      return this.detectDevice == 'mobile'
    },
    component() {
      return Object.prototype.hasOwnProperty.call(this.pageProductComponent, 'SECTION_PAGE') ? this.pageProductComponent.SECTION_PAGE : null
    },
    cssVars() {
      return {
        "--all-product-filter-width": "100%",
        "--all-product-filter-border-color": color.getColor(this.filterConfig.borderColor, this.filterConfig.borderColorAlpha),
        "--all-product-filter-background-color": color.getColor(this.filterConfig.backgroundColor, this.filterConfig.backgroundColorAlpha),
        "--all-product-filter-title-font-size": this.filterTitleStyle.fontIsCustom
          ? this.getResponsiveFontSize(this.filterTitleStyle.fontSize, "pageName") + "px"
          : this.getResponsiveFontSize(this.appearanceLanguage.font[this.filterTitleStyle.fontStyle].size, "pageName") + "px",
        "--all-product-filter-title-font-family": this.filterTitleStyle.fontIsCustom
          ? `"${this.filterTitleStyle.fontFamily}"` + ', "Tahoma"'
          : `"${this.appearanceLanguage.font[this.filterTitleStyle.fontStyle].family}"` + ', "Tahoma"',
        "--all-product-filter-title-font-weight": this.filterTitleStyle.fontIsCustom
          ? this.filterTitleStyle.fontIsBold ? "bold" : "normal"
          : this.appearanceLanguage.font[this.filterTitleStyle.fontStyle].isBold ? "bold" : "normal",
        "--all-product-filter-title-font-style": this.filterTitleStyle.fontIsCustom ? this.filterTitleStyle.fontIsItalic ? "italic" : "normal"
          : this.appearanceLanguage.font[this.filterTitleStyle.fontStyle].isItalic ? "italic" : "normal",
        "--all-product-filter-title-text-decoration": this.filterTitleStyle.fontIsCustom ? this.filterTitleStyle.fontIsUnderline ? "underline" : "unset"
          : this.appearanceLanguage.font[this.filterTitleStyle.fontStyle].isUnderline ? "underline" : "unset",
        "--all-product-filter-title-font-color": this.filterTitleStyle.fontIsCustom ? color.getColor(this.filterTitleConfig.fontColor) 
          : color.getColor(this.appearance.font[this.filterTitleStyle.fontStyle].color),
        "--all-product-filter-list-font-size": this.filterListStyle.fontIsCustom
          ? this.getResponsiveFontSize(this.filterListStyle.fontSize, "pageName") + "px"
          : this.getResponsiveFontSize(this.appearanceLanguage.font[this.filterListStyle.fontStyle].size, "pageName") + "px",
        "--all-product-filter-list-font-family": this.filterListStyle.fontIsCustom
          ? `"${this.filterListStyle.fontFamily}"` + ', "Tahoma"'
          : `"${this.appearanceLanguage.font[this.filterListStyle.fontStyle].family}"` + ', "Tahoma"',
        "--all-product-filter-list-font-weight": this.filterListStyle.fontIsCustom
          ? this.filterListStyle.fontIsBold ? "bold" : "normal"
          : this.appearanceLanguage.font[this.filterListStyle.fontStyle].isBold ? "bold" : "normal",
        "--all-product-filter-list-font-style": this.filterListStyle.fontIsCustom
          ? this.filterListStyle.fontIsItalic ? "italic" : "normal"
          : this.appearanceLanguage.font[this.filterListStyle.fontStyle].isItalic ? "italic" : "normal",
        "--all-product-filter-list-text-decoration": this.filterListStyle.fontIsCustom
          ? this.filterListStyle.fontIsUnderline ? "underline" : "unset"
          : this.appearanceLanguage.font[this.filterListStyle.fontStyle].isUnderline ? "underline" : "unset",
        "--all-product-filter-list-font-color": this.filterListStyle.fontIsCustom ? color.getColor(this.filterListConfig.fontColor)
          : color.getColor(this.appearance.font[this.filterListStyle.fontStyle].color),
        
        "--all-product-filter-button-border-radius": this.getButtonRadius(this.appearance.button.style),
        "--all-product-filter-button-background-color":
         color.getColor(
            this.appearance.button.backgroundColor,
            this.appearance.button.backgroundColorAlpha
          ),
        "--all-product-filter-button-background-color-hover":
          color.getColor(
            this.appearance.button.backgroundColorHover,
            this.appearance.button.backgroundColorAlphaHover
          ),
        "--all-product-filter-button-border-color":
          color.getColor(
            this.appearance.button.borderColor,
            this.appearance.button.borderColorAlpha
          ),
        "--all-product-filter-button-border-color-hover":
          color.getColor(
            this.appearance.button.borderColorHover,
            this.appearance.button.borderColorAlphaHover
          ),
        "--all-product-filter-button-font-color": color.getColor(this.appearance.button.fontColor),
        "--all-product-filter-button-font-color-hover": color.getColor(this.appearance.button.fontColorHover),
        "--all-product-filter-button-font-family": `"${this.appearanceLanguage.button.fontFamily}"` + ', "Tahoma"',
        "--all-product-filter-button-font-size": this.getResponsiveFontSize(
            this.appearanceLanguage.button.fontSize,
            "price"
          ) + "px",
        "--all-product-filter-button-fw": this.appearance.button.fontIsBold ? "bold" : "unset",
        "--all-product-filter-button-fsy": this.appearance.button.fontIsItalic ? "italic" : "unset",
        "--all-product-filter-button-fd": this.appearance.button.fontIsUnderline ? "underline" : "unset",
      };
    },
    filterConfig() {
      return this.pageProductConfig.style.filter;
    },
    filterTitleConfig() {
      return this.pageProductConfig.style.filterTitle;
    },
    filterTitleStyle() {
      return this.pageProductStyle.style.filterTitle;
    },
    filterListConfig() {
      return this.pageProductConfig.style.filterList;
    },
    filterListStyle() {
      return this.pageProductStyle.style.filterList;
    },
    categoryID() {
      let categoryID = this.component ? this.component.data.categoryID : null
      if (categoryID == null) {
        categoryID = {
          level1: 0,
          level2: 0,
          level3: 0,
          level4: 0,
        };
      }
      return categoryID;
    },
    arrayDisplay() {
      if (process.server && !this.filterData) return null
      let arr = [];
      if (this.isEnableStock) arr.push({ name: 'ProductFilterStock', type: 'stock', order: this.filterData ? this.filterData.stock.order : 0, isShow: true, filterName: this.filterData ? this.filterData.stock.name : 'Stock'})
      if (this.isEnableCategory) arr.push({ name: 'ProductFilterCategory', type: 'category', order: this.filterData ? this.filterData.category.order : 1, isShow: true, filterName: this.filterData ? this.filterData.category.name : 'Category'})
      if (this.isEnableBrand) arr.push({ name: 'ProductFilterBrand', type: 'brand', order: this.filterData ? this.filterData.brand.order : 2, isShow: true, filterName: this.filterData ? this.filterData.brand.name : 'Brand'})
      if (this.isEnableAttribute) arr.push({ name: 'ProductFilterAttribute', type: 'attribute', order: this.filterData ? this.filterData.attribute.order : 3, isShow: this.filterData.attribute.data.length == 0 ? false : true, filterName: this.filterData ? this.filterData.attribute.name : 'Attribute'})
      if (this.isEnablePrice) arr.push({ name: 'ProductFilterPrice', type: 'price', order: this.filterData ? this.filterData.price.order : 4, isShow: this.filterData.price.data.min == this.filterData.price.data.max ? false : true, filterName: this.filterData ? this.filterData.price.name : 'Price'})
      if (this.isEnableRating) arr.push({ name: 'ProductFilterRating', type: 'rating', order: this.filterData ? this.filterData.rating.order : 5, isShow: this.filterData.rating.data.length == 0 ? false : true, filterName: this.filterData ? this.filterData.rating.name : 'Rating'})
      if (this.isEnableStatus) arr.push({ name: 'ProductFilterStatus', type: 'status', order: this.filterData ? this.filterData.status.order : 6, isShow: this.filterData.status.data.length == 1 ? false : true, filterName: this.filterData ? this.filterData.status.name : 'Status'})
      return arr.sort((a, b) => {return a.order - b.order})
    },
    numItemFilterSelected() {
      let numItem = 0
      if (this.paramsUrlFilter.includes('category=')) {
        numItem += 1
      }
      if (this.selectedAttributes.length > 0) {
        numItem += this.selectedAttributes.length
      }
      if (this.selectedBrands.length > 0) {
        numItem += this.selectedBrands.length
      }
      if (this.selectedRatings.length > 0) {
        numItem += this.selectedRatings.length
      }
      if (this.selectedStatus.length > 0) {
        numItem += this.selectedStatus.length
      }
      if (this.selectedInstock) {
        numItem += 1
      }
      if (this.paramsUrlFilter.includes('price=')) {
        numItem += 1
      }
      return numItem
    },
    hideFilterRating() {
      return this.permissionWebsite.isRatingAndReview == '0' || !this.productReviewConfig.isEnable
    },
  },
  methods: {
    setSelectedCategory() {
      if (this.categoryID.level4) {
        this.selectedCategory =  [this.categoryID.level1, this.categoryID.level2, this.categoryID.level3, this.categoryID.level4]
      } else if (this.categoryID.level3) {
        this.selectedCategory =  [this.categoryID.level1, this.categoryID.level2, this.categoryID.level3, "0"]
      }  else if (this.categoryID.level2) {
        this.selectedCategory =  [this.categoryID.level1, this.categoryID.level2, "0", "0"]
      }  else if (this.categoryID.level1){
        this.selectedCategory =  [this.categoryID.level1, "0", this.categoryID.level3, "0"]
      } else {
        this.selectedCategory =  ["0", "0", "0", "0"];
      }
    },
    closeMenu() {
      this.$store.dispatch("designIframe/setOpenFilterProductMobile", false);
    },
    reRender() {
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    },
    getResponsiveFontSize(fontSize, field) {
      let maxFontSize = this.fontSizeConfigs[this.detectDevice][field].max;
      let size = fontSize > maxFontSize ? maxFontSize : fontSize;

      if (this.detectDevice == "mobile") {
        return responsiveFontSize(size);
      } else {
        return size;
      }
    },
    async getFilterProduct() {
      this.loading = true;
      let params = {
        language: this.languageUse,
        categoryLv1: this.categoryID.level1 || 0,
        categoryLv2: this.categoryID.level2 || 0,
        categoryLv3: this.categoryID.level3 || 0,
        categoryLv4: this.categoryID.level4 || 0,
      };
      productWebsiteService.getFilterProduct(params).then((response) => {
        this.isEnableCategory = Object.prototype.hasOwnProperty.call(response, 'category') ? response.category.isEnable : false
        this.isEnableBrand = Object.prototype.hasOwnProperty.call(response, 'brand') ? response.brand.isEnable : false
        this.isEnableAttribute = Object.prototype.hasOwnProperty.call(response, 'attribute') ? response.attribute.isEnable : false
        this.isEnablePrice = Object.prototype.hasOwnProperty.call(response, 'price') ? response.price.isEnable : false
        this.isEnableRating = Object.prototype.hasOwnProperty.call(response, 'rating') ? response.rating.isEnable : false
        this.isEnableStatus = Object.prototype.hasOwnProperty.call(response, 'status') ? response.status.isEnable : false
        this.isEnableStock = Object.prototype.hasOwnProperty.call(response, 'stock') ? response.stock.isEnable : false
        this.categories = Object.prototype.hasOwnProperty.call(response, 'category') ? response.category.data : []
        this.brands = Object.prototype.hasOwnProperty.call(response, 'brand') ? response.brand.data : []
        this.attributes = Object.prototype.hasOwnProperty.call(response, 'attribute') ? response.attribute.data : []
        this.ratings = Object.prototype.hasOwnProperty.call(response, 'rating') ? response.rating.data : []
        this.status = Object.prototype.hasOwnProperty.call(response, 'status') ? response.status.data : []
        this.filterData = response
        // set price
        if (Object.prototype.hasOwnProperty.call(response, 'price')) {
          if (Number(response.price.data.min) >= Number(response.price.data.max)) {
            this.prices = { min: Number(0), max: Number(response.price.data.max) }
          } else {
            this.prices = { min: Number(response.price.data.min), max: Number(response.price.data.max) }
          }
        } else {
          this.prices = { min: Number(0), max: Number(1000) }
        }
        if (!this.selectedPrices.min) {
          this.selectedPrices.min = this.prices.min
        }
        if (!this.selectedPrices.max) {
          this.selectedPrices.max = this.prices.max
        }
        this.loading = false;
      });
    }, 
    getDataRenderComponent(type) {
      switch (type) {
        case 'category':
          return {
            data: this.categories,
            selected: this.selectedCategory
          }
        case 'price':
          return {
            data: this.prices,
            selected: this.selectedPrices
          }
        case 'brand':
          return {
            data: this.brands,
            selected: this.selectedBrands
          }
        case 'attribute':
          return {
            data: this.attributes,
            selected: this.selectedAttributes
          }
        case 'rating':
          return {
            data: this.ratings,
            selected: this.selectedRatings
          }
        case 'status':
          return {
            data: this.status,
            selected: this.selectedStatus
          }
        default:
          break;
      }
    },
    onChange(type, value) {
      switch (type) {
        case 'category':
          this.selectedCategory = value;
          this.genParamsUrlFilter()
          break;
        case 'price':
          this.selectedPrices = value;
          this.genParamsUrlFilter()
          break;
        case 'brand':
          this.selectedBrands = value;
          this.genParamsUrlFilter()
          break;
        case 'attribute':
          this.selectedAttributes = value;
          this.genParamsUrlFilter()
          break;
        case 'rating':
          this.selectedRatings = value;
          this.genParamsUrlFilter()
          break;
        case 'status':
          this.selectedStatus = value;
          this.genParamsUrlFilter()
          break;
        case 'stock':
          this.selectedInstock = value;
          this.genParamsUrlFilter()
          break;
        default:
          break;
      }
    },
    genParamsUrlFilter() {
      let paramsUrl = `/&show=`
      if (this.selectedInstock) {
        paramsUrl += '&stock=instock'
      }
      if (this.selectedCategory.length > 0) {
        let cateID = this.selectedCategory.join('-')
        if (cateID != '0-0-0-0') {
          paramsUrl += `&category=${cateID}`
        }
      }
      if (this.selectedBrands.length > 0) {
        paramsUrl += `&brand=${this.selectedBrands.join(',')}`
      }
      if (this.selectedAttributes.length > 0) {
        paramsUrl += `&attribute=${this.selectedAttributes.join(',')}`
      }
      if ((Number(this.selectedPrices.min) != Number(this.prices.min)) || (Number(this.selectedPrices.max) != Number(this.prices.max))) {
        paramsUrl += `&price=${this.selectedPrices.min},${this.selectedPrices.max}`
      }
      if (this.selectedRatings.length > 0) {
        paramsUrl += `&rating=${this.selectedRatings.join(',')}`
      }
      if (this.selectedStatus.length > 0) {
        paramsUrl += `&status=${this.selectedStatus.join(',')}`
      }
      this.paramsUrlFilter = paramsUrl
    },
    apply() {
      this.closeMenu();
    },
    clearFilter() {
      this.selectedCategory = ["0", "0", "0", "0"]
      this.selectedAttributes = []
      this.selectedBrands = []
      this.selectedPrices.min = Number(this.prices.min)
      this.selectedPrices.max = Number(this.prices.max)
      this.selectedRatings = []
      this.selectedStatus = []
      this.selectedInstock = false
      this.genParamsUrlFilter()
      this.closeMenu()
      this.apply()
    },
    getButtonRadius(buttonStyle) {
      switch (buttonStyle) {
        case "square":
        case "button_square":
          return "0px";
        case "rounded":
        case "button_round":
          return "10px";
        case "rounder":
        case "button_rounder":
          return "50px";
        default:
          return "0px";
      }
    },
  },
  mounted() {
    this.setSelectedCategory();
    this.closeMenu();
  },
};
</script>

<style lang="scss">
.mwe-page-product-wrapper-filter-mobile-overlay {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  display: none;
  &.show {
    display: block;
  }
}
.mwe-page-product-wrapper-filter-mobile {
  border: 1px solid #DEE3E6;
  border-radius: 4px;
  background: var(--all-product-filter-background-color);
  border-color: var(--all-product-filter-border-color);
  height: 100vh;
  z-index: 6;
  max-width: 90vw;
  min-width: 200px;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  overflow: hidden;
  -webkit-transform: translate3d(100vw, 0, 0);
  -moz-transform: translate3d(100vw, 0, 0);
  -ms-transform: translate3d(100vw, 0, 0);
  transform: translate3d(100vw, 0, 0);
  -webkit-transition: transform 0.2s linear;
  -moz-transition: transform 0.2s linear;
  -o-transition: transform 0.2s linear;
  transition: all 0.2s linear;
  &.expand {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .product-filter-title-mobile {
    font-family: 'Sarabun';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #373E44;
  }
  .filter-scroll-wrapper {
    overflow-y: auto;
    height: calc(100% - (57px + 64px));
    overscroll-behavior: contain;
  }
  .mwe-page-product-filter {
    .product-filter-box {
      padding: 16px;
      border-bottom: 1px solid #DEE3E6;
      border-color: var(--all-product-filter-border-color);
      &:last-child {
        border-bottom: none;
      }
      .mwe-page-product-filter-list {
        font-size: var(--all-product-filter-list-font-size);
        font-family: var(--all-product-filter-list-font-family);
        color: var(--all-product-filter-list-font-color);
      }
      .filter-checkbox {
        align-self: flex-start;
        .custom-control-label::before {
          border: solid 1px #DEE3E6;
        }
        .custom-control-label::after {
          cursor: pointer;
        }
        .custom-checkbox .custom-control-input:checked~.custom-control-label::before,
        .custom-checkbox .b-custom-control-input:checked~.b-custom-control-label::before {
          background-color: #373e44;
          border: solid 1px #373e44;
        }
        .custom-control-input:focus ~ .custom-control-label::before {
            box-shadow: none;
            border-color: solid 1px #DEE3E6;
        }
        .custom-checkbox .custom-control-input:checked~.custom-control-label::after {
            background-image: url('/images/icon/check-checkbox.svg') !important;
            transform: scale(1.3);
        }
      }
    }
    .button-box {
      position: fixed;
      bottom: 0;
      right: 0;
      width: 100%;
      border-top: 1px solid;
      border-color: var(--all-product-filter-border-color);
      background: var(--all-product-filter-background-color);
      z-index: 7;
      button {
        font-family: 'Sarabun';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        display: flex;
        align-items: center;
        text-align: center;
        border-radius: 4px;
        border: transparent;
      }
      .clear {
        font-size: var(--all-product-filter-title-font-size);
        font-family: var(--all-product-filter-title-font-family);
        color: var(--all-product-filter-title-font-color);
        text-decoration: underline;
        background: transparent;

      }
      .apply {
        background: var(--all-product-filter-button-background-color);
        border-color: var(--all-product-filter-button-border-color);
        color: var(--all-product-filter-button-font-color);
        font-family: var(--all-product-filter-button-font-family);
        font-size: var(--all-product-filter-button-font-size);
        font-weight: var(--all-product-filter-button-fw);
        text-decoration: var(--all-product-filter-button-fd);
        font-style: var(--all-product-filter-button-fsy);

        &:hover {
          background: var(--all-product-filter-button-background-color-hover);
          border-color: var(--all-product-filter-button-border-color-hover);
          color: var(--all-product-filter-button-font-color-hover);
        }
      }
    }
    .mwe-page-product-filter-price {
      input[type="number"] {
        max-width: 100px;
      }
    }
  }
  .filter-item-group {
    /* max-height: 0;
    overflow: hidden;
    -webkit-transition: max-height 0.2s;
    -moz-transition: max-height 0.2s;
    -o-transition: max-height 0.2s;
    transition: max-height 0.2s; */
    &.category {
      cursor: pointer;
    }
    &.lv2 { 
      padding-left: 10px;
    }
    &.lv3 {
      padding-left: 10px;
    }
    &.lv4 {
      padding-left: 10px;
    }
    /* &.show {
      max-height: 10000vh;
      -webkit-transition: max-height 1s;
      -moz-transition: max-height 1s;
      -o-transition: max-height 1s;
      transition: max-height 1s;
    } */
    &.collapse:not(.show) {
      display: block !important;
      height: 0;
      overflow: hidden;
    }
    .filter-item {
      display: flex;
      align-items: center;
      padding: 5px 0;
      .pd-filter-icon {
          color: var(--all-product-filter-list-font-color);
        }
      &.filter-title { 
        justify-content: space-between;
        cursor: pointer;

        .pd-filter-icon {
          color: var(--all-product-filter-title-font-color);
        }
      }
      &.category {
        display: flex;
        justify-content: space-between;
        max-width: calc(100% - 8px);
        &:not(.filter-title) {
          &.active {
            .filter-item-title {
              font-weight: bold;
              text-decoration: underline;
            }
          }
        }
      }
      .filter-item-title {
        font-size: var(--all-product-filter-list-font-size);
        font-family: var(--all-product-filter-list-font-family);
        color: var(--all-product-filter-list-font-color);
        &.filter-title {
          font-size: var(--all-product-filter-title-font-size);
          font-family: var(--all-product-filter-title-font-family);
          color: var(--all-product-filter-title-font-color);
          font-weight: bold;
        }
        &.category:not(.filter-title):hover > div {
            text-decoration: underline;
        }
      }
      .pd-filter-icon {
        position: relative;
        width: 16px;
        height: 16px;
        padding: 8px;
        .icon-expand1 {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          -webkit-transition: all .2s;
          -moz-transition: all .2s;
          -o-transition: all .2s;
          transition: all .2s;
        }
        .icon-expand2 {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(90deg);
          display: block;
          -webkit-transition: all .2s;
          -moz-transition: all .2s;
          -o-transition: all .2s;
          transition: all .2s;
        }
        &.active {
          .icon-expand1 {
            transform: translate(-50%, -50%) rotate(180deg);
          }
          .icon-expand2 {
            transform: translate(-50%, -50%) rotate(180deg);
          }
        }
      }
      .filter-count-product {
        font-family: 'Sarabun';
        font-weight: normal;
        font-size: 14px;
        color: #A5A5A5;
      }
    }
    &.height-empty {
      height: 10px
    }
  }
  .filter-item-group:hover {
    .filter-item { 
      &.category:not(.filter-title) {
        max-width: calc(100% - 4px);
      }
    }
  }
  /* hide arrow input type number */
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
}
</style>
